// zn.js
export default {
  返回: "返回",
  方案概述: "方案概述",
  方案价值: "方案价值",
  方案架构图: "方案架构图",
  相关产品: "相关产品",
  典型案例: "典型案例",
  在线体验: "在线体验",
  欢迎来到解决方案展厅: " 欢迎来到解决方案展厅",
  "算能解决方案 助力数字中国建设，让国产算力普惠千行百业":
    "算能解决方案 助力数字中国建设，让国产算力普惠千行百业",
  "面向丰富的业务场景，提供整套行业和技术解决方案，助力客户数字化转型":
    "面向丰富的业务场景，提供整套行业和技术解决方案，助力客户数字化转型",
  显示更多案例: "显示更多案例",
  算丰赋能伙伴案例: "算丰赋能伙伴案例",
  了解详情: "了解详情",
  "（账号密码联系我们获取）": "（账号密码联系我们获取）",
  项目咨询: "项目咨询",
  "请填写以下表单，我们的销售代表会尽快与您联系":
    "请填写以下表单，我们的销售代表会尽快与您联系",
  工作邮箱: "工作邮箱",
  城市: "城市",
  公司: "公司",
  行业: "行业",
  需求: "需求",
  请输入需求描述: "请输入需求描述",
  "提交成功！我们会尽快与您联系": "提交成功！我们会尽快与您联系",
  联系我们: "联系我们",
  "项目咨询，可直接拨打": "项目咨询，可直接拨打",
  "将体验到VIP顾问式售前咨询，提供个性化解决方案":
    "将体验到VIP顾问式售前咨询，提供个性化解决方案",
  步数: "步数",
  权重: "权重",
  强度: "强度",
  随机的种子: "随机的种子",
  欢迎来到智能书法: "欢迎来到智能书法",
  请输入文字: "请输入文字",
  "字体风格:": "字体风格:",
  "生成中...": "生成中...",
  开始生成: "开始生成",
  长按图片保存: "长按图片保存",
  毛体: "毛体",
  王羲之体: "王羲之体",
  八大山人体: "八大山人体",
  米芾体: "米芾体",
  请填写: "请填写",
};
